/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {Mdx} from '../../components/Mdx.js';
const MDXLayout = function SecurityDisclosurePage(props) {
  return _jsx(Mdx, props);
};
export async function getStaticProps() {
  return {
    props: {
      i18nTitle: ['securityDisclosurePage.title']
    }
  };
}
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h1: "h1",
      p: "p",
      h2: "h2",
      em: "em",
      ul: "ul",
      li: "li",
      code: "code",
      a: "a"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h1, {
        children: "Responsible Disclosure Policy"
      }), "\n", _jsxs("div", {
        className: "lead",
        children: [_jsx("p", {
          children: _jsx(_components.p, {
            children: "Security is a top priority for Socket Inc, the company behind Wormhole. Socket believes that working with security researchers is crucial in making the web safer."
          })
        }), _jsx("p", {
          children: _jsx(_components.p, {
            children: "If you believe you've found a security issues in our product or service, we encourage you to notify us. We will work with you to resolve the issue promptly. Thanks in advance!"
          })
        })]
      }), "\n", _jsx(_components.h2, {
        children: "Bounty Schedule"
      }), "\n", _jsxs(_components.p, {
        children: ["This is ", _jsx(_components.em, {
          children: "approximately"
        }), " how much we expect to pay for reports. Understand that this is a guide – it's meant to help set expectations."]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "$0 — We're aware of this, or we don't really see it as a security issue."
        }), "\n", _jsx(_components.li, {
          children: "$100 — While this bug is appropriately categorized as a security issue, it doesn't present much risk and isn't a priority to fix."
        }), "\n", _jsx(_components.li, {
          children: "$250 — A minor security problem. It's likely not getting fixed in the next release."
        }), "\n", _jsx(_components.li, {
          children: "$500 — Definitely a real problem that puts users at risk. We will ship a fix in a scheduled release."
        }), "\n", _jsx(_components.li, {
          children: "$1000 and beyond — A really bad problem. We're probably going to ship a fix for this before our next scheduled release. We hope we don't have many of these problems – but if we do, we really want to hear about them."
        }), "\n"]
      }), "\n", _jsx(_components.h2, {
        children: "Disclosure Policy"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "If you believe you've discovered a potential security issue, please let us know by emailing us at security@socket.dev. We will acknowledge your email within five business days. Please only use this address to report security flaws and not for general product support."
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "Provide us with a reasonable amount of time to resolve the issue before disclosing it to the public or a third party. We aim to resolve critical issues within ten business days of disclosure."
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "Make a good faith effort to avoid privacy violations, destruction of data, and interruption or degradation of our service. Only interact with accounts you own or with explicit permission of the account holder."
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "If you would like to send us an encrypted report, email us with a request for us to set up a PGP key. We will reply with the PGP long key ID and post it on this page."
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "We are generally happy to publicly disclose reports two weeks after shipping the release which contains the fix."
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.h2, {
        children: "Scope"
      }), "\n", _jsx(_components.p, {
        children: "The following are explicitly in scope for this program:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.code, {
            children: "wormhole.app"
          }), " and all its subdomains"]
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://github.com/SocketDev/wormhole-crypto",
            children: _jsx(_components.code, {
              children: "wormhole-crypto"
            })
          })
        }), "\n"]
      }), "\n", _jsx(_components.h2, {
        children: "Exclusions"
      }), "\n", _jsx(_components.p, {
        children: "While researching, we'd like you to refrain from:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Denial of service"
        }), "\n", _jsx(_components.li, {
          children: "Spamming"
        }), "\n", _jsx(_components.li, {
          children: "Social engineering (including phishing) of Socket employees or contractors"
        }), "\n", _jsx(_components.li, {
          children: "Any physical attempts against Socket's physical property or data centers"
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "Thank you for helping to keep our users safe!"
      }), "\n", _jsx(_components.h2, {
        children: "Changes"
      }), "\n", _jsx(_components.p, {
        children: "We may revise these guidelines from time to time. The most current version of the guidelines will be available at https://wormhole.app/security/disclosure."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.em, {
          children: "Last updated: 2021-04-15"
        })
      })]
    });
  }
}
export default MDXContent;
